import {IPriceBand} from '../../../../shared/shared-models/price-banding/price-band';

export type TPriceBandingSource = 'store' | 'global';

/**
 * Store-scoped price banding view used by Feature → Stock Settings.
 */
export interface IPriceBandingStoreSettings {
  bands: IPriceBand[];
  source: TPriceBandingSource;
}
